/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 41);
/******/ })
/************************************************************************/
/******/ ({

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// var angular = require('angular');
// var _ = require('lodash');

(function () {
    'use strict';

    angular.module('app').service('authService', authService);

    authService.$inject = ['$timeout', '$http', '$sessionStorage', 'apiBaseUrl'];

    function authService($timeout, $http, $sessionStorage, apiUrl) {
        this.authorize = function () {
            return this.getInfo().then(function (info) {
                if (info.authenticated === true) return true;
                // anonymous
                throw new softship.helpers.AuthorizationError();
            });
        };

        this.getInfo = function () {
            return $timeout(function () {
                return $sessionStorage;
            }, 100);
        };

        this.retrieveEnvironment = function () {
            return $http.post(apiUrl + 'api/authenticate/AuthenticationService.asmx/GetEnvironment', {}, { responseType: 'json' }).then(function (resp) {
                $sessionStorage.environment = resp.data.d.environment;
                return;
            });
        };

        this.login = function (userName, password) {
            return $http.post(apiUrl + 'api/authenticate/AuthenticationService.asmx/Authenticate', { userName: userName, password: password }, { responseType: 'json' }).then(function (resp) {
                $sessionStorage.authenticated = resp.data.d.authenticated;

                // put in session scope
                $sessionStorage.logonInfo = {
                    username: userName,
                    loggedInSince: resp.data.d.loggedInSince,
                    isAnonymous: resp.data.d.isAnonymousUser,
                    security: resp.data.d.security
                };
                return resp.data;
            });
        };

        this.loginUsingTicket = function (ticketId) {
            return $http.post(apiUrl + 'api/authenticate/AuthenticationService.asmx/AuthenticateUsingTicket', { ticketId: ticketId }, { responseType: 'json' }).then(function (resp) {
                $sessionStorage.authenticated = resp.data.d.authenticated;

                // put in session scope
                $sessionStorage.logonInfo = {
                    username: resp.data.d.user,
                    loggedInSince: resp.data.d.loggedInSince,
                    isAnonymous: resp.data.d.isAnonymousUser,
                    security: resp.data.d.security
                };
                return resp.data;
            });
        };

        this.logout = function () {
            $sessionStorage.authenticated = false;
            $sessionStorage.logonInfo = {};
        };
    }
})();

/***/ })

/******/ });


// WEBPACK FOOTER //
// auth_f61149ed4534c2438558.js